export default {
    driver_performance_driverDetail_overview_cases: "Casos",
    driver_performance_driverDetail_overview_view: "Ver",
    driver_performance_driverDetail_overview_casesId: "ID de Casos",
    driver_performance_driverDetail_overview_status: "Estado",
    driver_performance_driverDetail_overview_created: "Creado",
    driver_performance_driverDetail_overview_piSuccess: "Éxito de PI",
    driver_performance_driverDetail_overview_eventSummary: "Resumen de Eventos",
    driver_performance_driverDetail_overview_risk: "Riesgo",
    driver_performance_driverDetail_overview_count: "Conteo",
    driver_performance_driverDetail_overview_score: "Puntaje",
    driver_performance_driverDetail_overview_yes: "Sí",
    driver_performance_driverDetail_overview_no: "No",
}